"use client";

import LoginPage from "@/app/versioning/page/LoginPage";

export default LoginPage;
